import {AirtableHomepageItem, HomepageCarousel} from '../../models/airtable';

const ContentKey = [
  'TopBanner',
  'LoyaltyAd',
  'DiscoverFeature',
  'HeroBrands',
  'AlertBanner',
] as const;

type HomepageContentKey = (typeof ContentKey)[number];

export const isValidContentKey = (key: unknown): key is HomepageContentKey =>
  ContentKey.includes(key as HomepageContentKey);

export interface UseHomepageParams {
  storeNumber?: string;
  storeState?: string;
  page?: string;
}

export interface UseHomepageResult {
  data: Record<string, AirtableHomepageItem>;
  carousel: HomepageCarousel | undefined;
  unknownData: Record<string, AirtableHomepageItem>;
}
